import React, {useEffect, useState} from 'react';
import {Button, Row, Col} from 'reactstrap';

import {
    Formik,
    Form,
    Field
} from 'formik';

import InputText from "./InputText";

import '../i18/config';
import {useTranslation} from "react-i18next";
import {ContentModalTwoStepValidatorSchema} from "./ValidatorModalTwoStep";
import AgainTimer from "./AgainTimer";

interface CodeConfirmationProps {
    cancelButtonText?: string;
    confirmButtonText?: string;
    showCancelButton?: boolean;
    handleCancel?: ()=>void;
    onChange: (code:string) => void;
    onResendConfirmation?: () => void;
    timerDuration?: number;
}

interface CodeConfirmationFormValues {
    codeInput0: string,
    codeInput1: string,
    codeInput2: string,
    codeInput3: string,
    codeInput4: string,
}

const InitialCodeConfirmationFormValues: CodeConfirmationFormValues = {
    codeInput0:'',
    codeInput1:'',
    codeInput2:'',
    codeInput3:'',
    codeInput4:'',
}


const CodeConfirmation = ({
                              cancelButtonText = 'close',
                              confirmButtonText= 'confirm',
                              showCancelButton = false,
                              handleCancel,
                              onChange,
                              onResendConfirmation,
                              timerDuration = 0
    }:CodeConfirmationProps
) => {

    const { t } = useTranslation(['common']);
    const [formValues, setFormValues] = useState<CodeConfirmationFormValues>(null);

    const codeFormPrefix = 'codeInput';

    const codeLength = 5;

    const setInitialValues = () => {
        let newFormValues : CodeConfirmationFormValues = {
            ...InitialCodeConfirmationFormValues
        };

        setFormValues({...newFormValues});
    }
    useEffect(() => {
        setInitialValues();
    },[]);

    const onDataSubmit = (formData:any) =>{

        let verificationCode='';

        [...Array(codeLength)].map((x:number, i: number) => {
            if (formData[codeFormPrefix+i] !== undefined){
                verificationCode+=formData[codeFormPrefix+i];
            }
            return x;
        });

        if (verificationCode.length===codeLength){
            onChange(verificationCode)
        //    setInitialValues();
        }
    }

    const handleKeyDown = (e) => {
        if (e.key === "Backspace") {
                const digits = e.target.id.match(/\d+/);
                if (digits) {
                    if (digits[0] > 0) {
                        let newFormValues : CodeConfirmationFormValues = {...formValues}
                        let itemKey = codeFormPrefix + (digits[0]-1);

                        if ((parseInt(digits[0]) === codeLength-1) && (e.target.value.length > 0)){
                            itemKey = codeFormPrefix + digits[0];
                        }

                        newFormValues[itemKey]='';

                        setFormValues({...newFormValues});
                        document.getElementById(itemKey).focus();
                    }
                }
        }
    };

    const handlePaste = (e) => {
        e.preventDefault(); // Prevent default paste behavior

        const pastedData = e.clipboardData.getData('text/plain');
        const characters = pastedData.split('');

        if (characters.length > 0) {
            let newFormValues : CodeConfirmationFormValues = {...InitialCodeConfirmationFormValues}

            characters.map((x:string, i:number) => {
                if (i<codeLength){
                    newFormValues[codeFormPrefix+i]=x;
                }
                return true;
            });

            setFormValues({...newFormValues});

            document.getElementById(codeFormPrefix + (characters.length<5?characters.length:4)).focus();

        }
    }

    return (
                <Formik
                    enableReinitialize={true}
                    initialValues={formValues}
                    validationSchema={ContentModalTwoStepValidatorSchema}
                    onSubmit={(values, actions) => {
                        onDataSubmit(values);
                        actions.setSubmitting(false);
                    }}
                >
                    {({ errors, touched, setFieldValue, getFieldProps, isSubmitting, isValidating }) =>
                        (<>
                                <Form noValidate={true} className="customValidation">
                                    <Row className="flex-nowrap g-2 justify-content-center mb-5">
                                        {[...Array(codeLength)].map((x: number, i: number) => (
                                            <Col
                                                className={"w-20" + (touched[codeFormPrefix + i] ? " was-validated" : '')}
                                                key={'twoStep_' + i}
                                            >
                                                <Field
                                                    id={codeFormPrefix + i}
                                                    autoFocus={i === 0}
                                                    name={codeFormPrefix + i}
                                                    component={InputText}
                                                    value={getFieldProps(codeFormPrefix + i).value}
                                                    onChange={(value: string) => {
                                                        setFieldValue(codeFormPrefix + i, value);
                                                        if ((i < codeLength - 1) && value.length>0){
                                                            document.getElementById(codeFormPrefix + (i + 1)).focus();
                                                        }
                                                    }}
                                                    className="form-control bg-light border-light text-center"
                                                    maxLength="1"
                                                    onKeyDown={handleKeyDown}
                                                    onPaste={handlePaste}
                                                    required={true}
                                                />
                                            </Col>
                                        ))
                                        }
                                    </Row>
                                    <div className="hstack gap-2 justify-content-center mb-4">
                                        {timerDuration > 0 &&
                                        <AgainTimer
                                            initialDuration={timerDuration}
                                            onFinish={onResendConfirmation}
                                            label={t('auth:sendAgain')}
                                        />
                                        }
                                        {showCancelButton &&
                                        <Button to="#" className="btn btn-light fw-medium" onClick={handleCancel}>
                                            <i className="ri-close-line me-1 align-middle"/> {t('common:'+cancelButtonText)}
                                        </Button>
                                        }
                                        <Button to="#" className="btn btn-success"
                                                type="submit">{t('common:'+confirmButtonText)}</Button>
                                    </div>
                                </Form>
                            </>
                        )
                    }
                </Formik>
    );
};

export default CodeConfirmation;